var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"title font-weight-light blue-grey--text"},[_c('v-flex',[_vm._v("Attributos")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }